import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class DateTimeService2 {

    private readonly formatDateTime = 'yyyy-MM-dd HH:mm:ss';
    private readonly formatDate = 'yyyy-MM-dd';
    private readonly formatTime = 'HH:mm';
    private readonly locale = 'en-US';

    getDateTimeFormat(): string {
        return this.formatDateTime;
    }

    getDateFormat(): string {
        return this.formatDate;
    }

    getTimeFormat(): string {
        return this.formatTime;
    }

    getFormattedDateTime(value: Date | string | number): string {
        return formatDate(this.toDate(value), this.formatDateTime, this.locale);
    }

    getFormattedDate(value: Date | string | number): string {
        return formatDate(this.toDate(value), this.formatDate, this.locale);
    }

    getFormattedTime(value: Date | string | number): string {
        return formatDate(this.toDate(value), this.formatTime, this.locale);
    }

    private toDate(value: Date | string | number): Date {
        return value instanceof Date ? value : new Date(value); 
    }
}
